/* eslint-disable */ /* tslint:disable */ // @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
export var ContentType;
(function(ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["JsonApi"] = "application/vnd.api+json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export var HttpClient = /*#__PURE__*/ function() {
    "use strict";
    function HttpClient() {
        var _this = this;
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, HttpClient);
        var securityWorker = _param.securityWorker, secure = _param.secure, format = _param.format, axiosConfig = _object_without_properties(_param, [
            "securityWorker",
            "secure",
            "format"
        ]);
        _define_property(this, "instance", void 0);
        _define_property(this, "securityData", null);
        _define_property(this, "securityWorker", void 0);
        _define_property(this, "secure", void 0);
        _define_property(this, "format", void 0);
        _define_property(this, "setSecurityData", function(data) {
            _this.securityData = data;
        });
        var _this1 = this;
        _define_property(this, "request", function() {
            var _ref = _async_to_generator(function(_param) {
                var secure, path, type, query, format, body, params, secureParams, _tmp, requestParams, responseFormat;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            secure = _param.secure, path = _param.path, type = _param.type, query = _param.query, format = _param.format, body = _param.body, params = _object_without_properties(_param, [
                                "secure",
                                "path",
                                "type",
                                "query",
                                "format",
                                "body"
                            ]);
                            _tmp = (typeof secure === 'boolean' ? secure : _this1.secure) && _this1.securityWorker;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.securityWorker(_this1.securityData)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            secureParams = _tmp || {};
                            requestParams = _this1.mergeRequestParams(params, secureParams);
                            responseFormat = format || _this1.format || undefined;
                            if (type === "multipart/form-data" && body && body !== null && typeof body === 'object') {
                                body = _this1.createFormData(body);
                            }
                            if (type === "text/plain" && body && body !== null && typeof body !== 'string') {
                                body = JSON.stringify(body);
                            }
                            return [
                                2,
                                _this1.instance.request(_object_spread_props(_object_spread({}, requestParams), {
                                    headers: _object_spread({}, requestParams.headers || {}, type ? {
                                        'Content-Type': type
                                    } : {}),
                                    params: query,
                                    responseType: responseFormat,
                                    data: body,
                                    url: path
                                }))
                            ];
                    }
                });
            });
            return function(_param) {
                return _ref.apply(this, arguments);
            };
        }());
        this.instance = axios.create(_object_spread_props(_object_spread({}, axiosConfig), {
            baseURL: axiosConfig.baseURL || 'http://{defaultHost}'
        }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    _create_class(HttpClient, [
        {
            key: "mergeRequestParams",
            value: function mergeRequestParams(params1, params2) {
                var method = params1.method || params2 && params2.method;
                return _object_spread_props(_object_spread({}, this.instance.defaults, params1, params2 || {}), {
                    headers: _object_spread({}, method && this.instance.defaults.headers[method.toLowerCase()] || {}, params1.headers || {}, params2 && params2.headers || {})
                });
            }
        },
        {
            key: "stringifyFormItem",
            value: function stringifyFormItem(formItem) {
                if (typeof formItem === 'object' && formItem !== null) {
                    return JSON.stringify(formItem);
                } else {
                    return "".concat(formItem);
                }
            }
        },
        {
            key: "createFormData",
            value: function createFormData(input) {
                var _this = this;
                if (_instanceof(input, FormData)) {
                    return input;
                }
                return Object.keys(input || {}).reduce(function(formData, key) {
                    var property = input[key];
                    var propertyContent = _instanceof(property, Array) ? property : [
                        property
                    ];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = propertyContent[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var formItem = _step.value;
                            var isFileType = _instanceof(formItem, Blob) || _instanceof(formItem, File);
                            formData.append(key, isFileType ? formItem : _this.stringifyFormItem(formItem));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return formData;
                }, new FormData());
            }
        }
    ]);
    return HttpClient;
}();
/**
 * @title API V1
 * @version v1
 * @baseUrl http://{defaultHost}
 */ export var Api = /*#__PURE__*/ function(HttpClient) {
    "use strict";
    _inherits(Api, HttpClient);
    var _super = _create_super(Api);
    function Api() {
        _class_call_check(this, Api);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "insightsApi", {
            /**
     * No description
     *
     * @tags insights_api/campaign_columns
     * @name ProjectsCampaignsColumnsList
     * @summary Retrieves the csv header column mapping for a campaign
     * @request GET:/insights_api/projects/{project_id}/campaigns/{id}/columns
     * @secure
     * @response `200` `InsightsApi` returns the correct columns hash
     * @response `401` `void` unauthorized
     */ projectsCampaignsColumnsList: function(param) {
                var projectId = param.projectId, id = param.id, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_api/projects/".concat(projectId, "/campaigns/").concat(id, "/columns"),
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
     * No description
     *
     * @tags insights_api/campaign_csv
     * @name ProjectsCampaignsDetail
     * @summary Retrieves a campaign result CSV
     * @request GET:/insights_api/projects/{project_id}/campaigns/{id}
     * @secure
     * @response `200` `void` returns a CSV file
     * @response `401` `void` unauthorized
     */ projectsCampaignsDetail: function(param) {
                var projectId = param.projectId, id = param.id, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_api/projects/".concat(projectId, "/campaigns/").concat(id),
                    method: 'GET',
                    secure: true
                }, params));
            },
            /**
     * No description
     *
     * @tags insights_api/projects_list
     * @name ProjectsList
     * @summary Retrieves a list of projects
     * @request GET:/insights_api/projects
     * @secure
     * @response `200` `InsightsApi` returns the filtered projects_list resource
     * @response `401` `void` unauthorized
     */ projectsList: function() {
                var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_api/projects",
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
     * No description
     *
     * @tags api/projects_show
     * @name ProjectsDetail
     * @summary Retrieve a single project
     * @request GET:/insights_api/projects/{id}
     * @secure
     * @response `200` `InsightsApi` returns a valid project resource
     * @response `401` `void` unauthorized
     */ projectsDetail: function(param) {
                var id = param.id, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_api/projects/".concat(id),
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            }
        });
        _define_property(_assert_this_initialized(_this), "insightsPlatform", {
            /**
     * No description
     *
     * @tags campaigns
     * @name CampaignsLaunchUpdate
     * @summary Launch a project
     * @request PUT:/insights_platform/campaigns/{id}/launch
     * @secure
     * @response `200` `void` launch a campaign
     * @response `401` `void` Unauthorized
     * @response `422` `void` Invalid Identifier
     */ campaignsLaunchUpdate: function(param) {
                var id = param.id, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/campaigns/".concat(id, "/launch"),
                    method: 'PUT',
                    secure: true
                }, params));
            },
            /**
 * No description
 *
 * @tags campaign_qualifications
 * @name CampaignQualificationsList
 * @summary Retrieves campaign qualifications belonging to a campaign quota
 * @request GET:/insights_platform/campaign_qualifications
 * @secure
 * @response `200` `{
    data?: ((CampaignQualification))[],

}` campaign_qualification found
 */ campaignQualificationsList: function(query) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/campaign_qualifications",
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
     * No description
     *
     * @tags update_country_language
     * @name CampaignsUpdateCountryLanguagePartialUpdate
     * @summary Updates the country/language of a campaign
     * @request PATCH:/insights_platform/campaigns/{id}/update_country_language
     * @secure
     * @response `200` `void` Country/language update successful
     * @response `401` `void` Unauthorized
     * @response `422` `void` Invalid Identifier
     */ campaignsUpdateCountryLanguagePartialUpdate: function(param, data) {
                var id = param.id, params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/campaigns/".concat(id, "/update_country_language"),
                    method: 'PATCH',
                    body: data,
                    secure: true,
                    type: "application/json"
                }, params));
            },
            /**
 * No description
 *
 * @tags longitudinal_question_result
 * @name LongitudinalTapQuestionsQuestionResultsList
 * @summary Retrieves the longitudinal question result
 * @request GET:/insights_platform/longitudinal/tap_questions/{identifier}/question-results
 * @secure
 * @response `200` `{
    data?: LongitudinalQuestionResult,

}` authorized
 * @response `401` `void` unauthorized
 */ longitudinalTapQuestionsQuestionResultsList: function(_param) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var identifier = _param.identifier, query = _object_without_properties(_param, [
                    "identifier"
                ]);
                return _this.request(_object_spread({
                    path: "/insights_platform/longitudinal/tap_questions/".concat(identifier, "/question-results"),
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags root_questions_list
 * @name ProjectsRootQuestionsListList
 * @summary Retrieves a list of questions
 * @request GET:/insights_platform/projects/{identifier}/root-questions-list
 * @secure
 * @response `200` `{
    data?: ((TapQuestion))[],

}` authorized
 * @response `401` `void` unauthorized
 */ projectsRootQuestionsListList: function(_param) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var identifier = _param.identifier, query = _object_without_properties(_param, [
                    "identifier"
                ]);
                return _this.request(_object_spread({
                    path: "/insights_platform/projects/".concat(identifier, "/root-questions-list"),
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags root_tap_answers_list
 * @name LongitudinalTapQuestionsRootTapAnswersListList
 * @summary Retrieves all root tap answers for a given root tap question ID
 * @request GET:/insights_platform/longitudinal/tap_questions/{identifier}/root-tap-answers-list
 * @secure
 * @response `200` `{
    data?: ((TapAnswer))[],

}` authorized
 * @response `401` `void` unauthorized
 */ longitudinalTapQuestionsRootTapAnswersListList: function(param) {
                var identifier = param.identifier, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/longitudinal/tap_questions/".concat(identifier, "/root-tap-answers-list"),
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags payment_methods
 * @name CustomersPaymentMethodsList
 * @summary Retrieves a collection of payment methods
 * @request GET:/insights_platform/customers/{identifier}/payment_methods
 * @secure
 * @response `200` `{
    data?: ((PaymentMethod))[],

}` authorized
 * @response `401` `void` unauthorized
 */ customersPaymentMethodsList: function(param) {
                var identifier = param.identifier, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/customers/".concat(identifier, "/payment_methods"),
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags project_review
 * @name ProjectsReviewList
 * @summary Retrieves a project review object
 * @request GET:/insights_platform/projects/{identifier}/review
 * @secure
 * @response `200` `{
    data?: ProjectReview,

}` project review found/authorized
 * @response `401` `void` user not authorized for project
 */ projectsReviewList: function(param) {
                var identifier = param.identifier, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/projects/".concat(identifier, "/review"),
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags projects
 * @name ProjectStatusCountsList
 * @summary Retrieves the count of projects by status
 * @request GET:/insights_platform/project_status_counts
 * @secure
 * @response `200` `{
    data?: ((ProjectStatusCount))[],

}` without filters applied returns the right counts
 */ projectStatusCountsList: function(param) {
                var projectType = param.projectType, date = param.date, userId = param.userId, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/project_status_counts",
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags project_waves
 * @name ProjectsWavesList
 * @summary Retrieves a collection of waves
 * @request GET:/insights_platform/projects/{identifier}/waves
 * @secure
 * @response `200` `{
    data?: ((Campaign))[],

}` authorized
 * @response `401` `void` unauthorized
 */ projectsWavesList: function(_param) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var identifier = _param.identifier, query = _object_without_properties(_param, [
                    "identifier"
                ]);
                return _this.request(_object_spread({
                    path: "/insights_platform/projects/".concat(identifier, "/waves"),
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags projects
 * @name ProjectsDetail
 * @summary Retrieves a project
 * @request GET:/insights_platform/projects/{identifier}
 * @secure
 * @response `200` `{
    data?: Project,

}` project found
 */ projectsDetail: function(param) {
                var identifier = param.identifier, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/projects/".concat(identifier),
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags qualification_answer_labels
 * @name QualificationAnswerLabelsList
 * @summary Retrieves qualification answer labels/buckets by question_id + country_id + language_id
 * @request GET:/insights_platform/qualification-answer-labels
 * @secure
 * @response `200` `{
    data?: ((QualificationAnswerLabel))[],

}` get labels success
 */ qualificationAnswerLabelsList: function(query) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/qualification-answer-labels",
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags qualifications
 * @name QualificationsList
 * @summary Retrieves available qualifications by country and language
 * @request GET:/insights_platform/qualifications
 * @secure
 * @response `200` `{
    data?: ((Qualification))[],
    included?: ((QualificationAnswer))[],

}` profiling qualifications only
 */ qualificationsList: function(query) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/qualifications",
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags qualifications
 * @name QualificationsDetail
 * @summary Retrieves a qualification
 * @request GET:/insights_platform/qualifications/{id}
 * @secure
 * @response `200` `{
    data?: Qualification,
    included?: ((QualificationAnswer))[],

}` qualification found
 */ qualificationsDetail: function(param) {
                var id = param.id, byQuestionId = param.byQuestionId, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _this.request(_object_spread({
                    path: "/insights_platform/qualifications/".concat(id),
                    method: 'GET',
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags tap_answers_list
 * @name TapQuestionsTapAnswersListList
 * @summary Retrieves all tap answers for a given tap question
 * @request GET:/insights_platform/tap_questions/{identifier}/tap-answers-list
 * @secure
 * @response `200` `{
    data?: ((TapAnswer))[],

}` authorized
 * @response `401` `void` unauthorized
 */ tapQuestionsTapAnswersListList: function(_param) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var identifier = _param.identifier, query = _object_without_properties(_param, [
                    "identifier"
                ]);
                return _this.request(_object_spread({
                    path: "/insights_platform/tap_questions/".concat(identifier, "/tap-answers-list"),
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags tap_question_cross_tab_result
 * @name TapQuestionsCrossTabResultsList
 * @summary Retrieves the single survey tap question cross tab result
 * @request GET:/insights_platform/tap_questions/{identifier}/cross-tab-results
 * @secure
 * @response `200` `{
    data?: TapQuestionCrossTabResult,

}` authorized
 * @response `401` `void` unauthorized
 */ tapQuestionsCrossTabResultsList: function(_param) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var identifier = _param.identifier, query = _object_without_properties(_param, [
                    "identifier"
                ]);
                return _this.request(_object_spread({
                    path: "/insights_platform/tap_questions/".concat(identifier, "/cross-tab-results"),
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags tap_question_result
 * @name TapQuestionsResultsList
 * @summary Retrieves the single survey tap question result
 * @request GET:/insights_platform/tap_questions/{identifier}/results
 * @secure
 * @response `200` `{
    data?: TapQuestionResult,

}` authorized
 * @response `401` `void` unauthorized
 */ tapQuestionsResultsList: function(_param) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var identifier = _param.identifier, query = _object_without_properties(_param, [
                    "identifier"
                ]);
                return _this.request(_object_spread({
                    path: "/insights_platform/tap_questions/".concat(identifier, "/results"),
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            },
            /**
 * No description
 *
 * @tags tap_survey_questions_list
 * @name TapSurveysQuestionsListList
 * @summary Retrieves a list of questions
 * @request GET:/insights_platform/tap_surveys/{identifier}/questions-list
 * @secure
 * @response `200` `{
    data?: ((TapQuestion))[],

}` authorized
 * @response `401` `void` unauthorized
 */ tapSurveysQuestionsListList: function(_param) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var identifier = _param.identifier, query = _object_without_properties(_param, [
                    "identifier"
                ]);
                return _this.request(_object_spread({
                    path: "/insights_platform/tap_surveys/".concat(identifier, "/questions-list"),
                    method: 'GET',
                    query: query,
                    secure: true,
                    format: 'json'
                }, params));
            }
        });
        return _this;
    }
    return Api;
}(HttpClient);
